var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayout4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 113,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 253,
    width: 125,
    height: 113
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34)",
    transform: "translate(-299 -253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.6 208.486 403.317 208.486 403.317 259.439 279.6 259.439Z",
    stroke: "current",
    strokeWidth: 1.26008,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00248 20.0411 44.639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.6 268.97 336.785 268.97 336.785 319.923 279.6 319.923Z",
    stroke: "current",
    strokeWidth: 1.26008,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00248 20.0411 44.639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.133 268.97 403.317 268.97 403.317 319.923 346.133 319.923Z",
    stroke: "current",
    strokeWidth: 1.26008,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    transform: "matrix(1 0 0 1.00248 20.0411 44.639)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout4);
export default __webpack_public_path__ + "static/media/layout4.06e519fd5bdf195a354b0b25ecfceb79.svg";
export { ForwardRef as ReactComponent };